<template>
<div class="row">

	<div :class="set_width_property">
		<!-- <div class="col-12 col-md-6 col-xl-3"> -->
			<div class="form-group input-content">
				<label>Location</label>
				<v-select class="mb-2"
				:searchable="true"
				@input="locationChangeHandler($event)"
				track-by="id" 
				label="name"
				allowClear="true"
				name="organization_location_id"
				v-model="current_location"
				:options="locations"
				v-validate="mandatory == 1 ? 'required' : '' "  
				:disabled="disabled_condition" >
				</v-select>
				<span class="input-error-msg">{{ errors.first('organization_location_id') }}</span>
			</div>
		</div>
		<!-- Sub Location !-->
			<div :class="[set_width_property, sub_location_disabled]">
			<div class="form-group input-content">
				<label>Sub Location</label>
				<v-select class="mb-2"  :searchable="true"  track-by="id" label="name"  allowClear="true"  name="organization_location_id"
						v-model="current_sublocation" :options="sub_location_options"
						>
				</v-select>
				<span class="input-error-msg">{{ errors.first('organization_location_id') }}</span>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props:{
		locations:{
			type: Array,
			required: true
		},
		selected_location:{
			required: true
		},
		mandatory:{
			type: Number
		},
		organization:{
			type: Object
		},
		width_full:{
			required: false,
			default: false
		}
	},
	computed:{
		disabled_condition(){
			if(this.width_full){
				return false
			}else{
				if(!this.organization.is_active){
					return true
				}else{
					return false
				}
			}
		},
		set_width_property(){
			if(this.width_full){
				return "col-12 col-md-6 "
			}else{
				return "col-12 col-md-6 col-xl-3"
			}
		},
		sub_location_disabled(){
			if(this.sub_location_options.length == 0){
				return 'input-disabled not-allowed'
			}else{
				return ''
			}
		}
	},
	data : function(){
		return{
			current_location:'',
			current_sublocation:'',
			location_to_send:{

			},
			sub_location_options:[]
		}
	},
	watch:{
		selected_location(val) {
			if(val) {
				this.getSelectedLocation(val)
			}
		},
		current_location(val) {
			if(val != '' && val != undefined && val != null && val != this.location_to_send.location){
				this.location_to_send.location = val
				this.$emit('locationChanged', val)
			}
		},
		current_sublocation(val) {
			if(val != '' || val != undefined || val != null){
				this.location_to_send.sub_location = val
				this.$emit('locationChanged', val)
			}
		}
	},
	mounted : function(){
		//this.current_location = this.selected_location
		if(this.selected_location != null){
			this.getSelectedLocation(this.selected_location)
		}
	},
	methods : {
		locationChangeHandler : function(val){
			console.log('$event val:' + JSON.stringify(val));			
			let temp_location;

			if (typeof val === 'string') {
				return;
			} else {
				temp_location = val;
			}
			
			//dont remove child value on first load
			if(temp_location && temp_location.children) {
				this.sub_location_options = temp_location.children	
			} else {
				const locationCheck = this.locations.find(elem => {
					if (elem.children && elem.id == temp_location.id) {
						return true;
					} else {
						return false;
					}
				});

				if (locationCheck) {
					return;
				} else {
					this.sub_location_options = [];
				}
			}

			if (this.selected_location && this.current_location) {
				if (this.selected_location.parent_id == this.current_location.id) {
					return
				} else {
					this.current_sublocation = ''
				}
			}
		},

		getSelectedLocation(val) {
			if (val && val.parent_id) {

				let temp_location = this.locations.find(elem => elem.id == val.parent_id);
				this.current_location = temp_location.name;

				this.sub_location_options = temp_location.children;
				this.current_sublocation = val;
			} else {
				//checking if has sublocations
				const locationCheck = this.locations.find(elem => {
					if (elem.children && elem.id == val.id) {
						return true;
					} else {
						return false;
					}
				});
				
				if (locationCheck) {
					this.sub_location_options = locationCheck.children;
				}

				this.current_location = val;
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/shared/inputs/SubLocationSelection.vue